import { CaptionAccentTypography, CaptionLinkTypography } from 'ui';

type Props = {
	text: string;
	linkText: string;
	link: string;
};

export const TermsOfServiceLink: React.FC<Props> = ({ text, link, linkText }) => {
	const onClick = () => {
		window.open(link, '_blank');
	};

	return (
		<div className="flex flex-row justify-center gap-[2px] text-black" data-testid="auth-tos">
			<CaptionAccentTypography>{text}</CaptionAccentTypography>
			<CaptionLinkTypography className="hover:cursor-pointer" onClick={onClick} data-testid="auth-tos-link">
				{linkText}
			</CaptionLinkTypography>
		</div>
	);
};
